import * as types from './constants';
import initialState from './state';

export default function PostsReducer(state = initialState, action) {
  switch (action.type) {
    case types.ADD_POST:
      return {
        ...state, posts: [{
          id: action.id,
          title: action.title,
          text: action.text
        }, ...state.posts]
      };

    case types.DELETE_POST:
      return {
        ...state, posts: state.posts.filter((post) => post.id !== action.id)
      };

    case types.CHECK_NEW_POSTS:
      return {...state, posts: action.posts.concat(state.posts)};

    case types.POSTS_LOADED:
      return {...state, posts: action.posts};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/Posts/reducer.js